<template>
  <router-link
    class="draft-product-component text-dark my-5 mb-md-3 px-2"
    :to="{ name: 'product-details', params: { id: product.id } }"
  >
    <div
      class="d-flex flex-column flex-md-row align-items-left align-items-md-center px-3"
    >
      <img v-if="product.picture" class="img-fluid" :src="product.picture" />
      <img
        v-else
        class="img-fluid"
        :src="require('@/assets/images/product-example-big.svg')"
      />
      <div class="flex-fill ml-md-5 mt-5 mt-md-0">
        <div class="d-flex align-item-center">
          <div class="flex-fill">
            <h5 class="product-name">{{ product.name }}</h5>
            <div class="d-flex align-items-center text-secondary">
              <small>
                {{
                  product.charge_type === "recurrent"
                    ? "Assinatura"
                    : "Curso online"
                }}
              </small>
            </div>
          </div>
        </div>
        <span class="draft-badge">
          Rascunho
        </span>
      </div>
      <!-- <div class="col d-lg-none">
        <router-link
          class="btn btn-outline-primary btn-block"
          :to="{ name: 'product-details', params: { id: product.id } }"
        >
          Ir para painel do produto
        </router-link>
      </div> -->
    </div>
  </router-link>
</template>
<script>
export default {
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  }
};
</script>
<style lang="scss" scoped>
.draft-product-component {
  display: flex;
  text-decoration: none;
  min-width: 327px;
  @media screen and (max-width: 767px) {
    min-width: 288px;
  }
  padding: 12px;
  transition: 0.3s all ease-in-out;

  @media screen and (max-width: 767px) {
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.12);
    border-radius: 4.86px;
    img {
      box-shadow: none !important;
    }
  }

  &:hover {
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.12);
    border-radius: 4.86px;
    img {
      box-shadow: unset;
    }
  }

  img {
    height: 68px;
    width: 68px;
    @media screen and (max-width: 767px) {
      width: 272px;
      height: 98px;
    }
    object-fit: cover;
    box-shadow: 0px 4.857142925262451px 4.857142925262451px 0px
      rgba(0, 0, 0, 0.25);
    border-radius: 4.86px;
    transition: 0.3s all ease-in-out;
  }

  .badge {
    font-weight: normal;
    color: white;
  }
  .product-name {
    width: 235px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
